module.exports = __webpack_public_path__ + "img/sheet.0f99b0b5.svg";